
import breedingManagementService from "@/app/services/main/breeding-management/breeding-management-service.js";

// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { comingSoonMixins } from "@/app/mixins/utils/coming-soon-mixins"
import { dateMixins } from "@/app/mixins/utils/date-mixins"
// Constants
import { STATUS_CODES } from "@/app/constants/status-constants"
import { BREEDER_ROUTES } from '@/app/constants/breeder-routes-constants';
import { capitalizeFirstLetter } from "@/utils/text-utils.js"

const PUPPY_GENDER = {
    MALE: "Male",
    FEMALE: 'Female',
}

export default {
    name: 'LitterListCardComponent.js',
    components: {},
    directive: {},
    filters: {},
    mixins: [
        tableMixins,
        toastMessageMixins,
        comingSoonMixins,
        dateMixins
    ],
    props: {},
    data() {
        return {
            isAPILoading: false,
            didFetchList: false,
            maxLittersCount: 15,
            isShowMore: false,
            limit: 15,
            // pagination
            page: 1,
            pageCount: 0,
            totalCount: 0,
            currentTotalCount: 0,
            // sorting
            sortBy: '',
            desc: true,
            columnsFilter: {},
            matingId: null,
            puppyList: [],
            puppyListTotalCount: 0,
            
            PUPPY_GENDER
        }
    },
    computed: {
        displayShowMoreButton() {
			return this.puppyListTotalCount != this.puppyList.length;
		}
    },
    watch: {},
    async created() {
        if (this.$route.query) {
            this.matingId = this.$route.query.id;
            this.currentTotalCount = await this.getTableContent();
        }
    },
    methods: {
        async getTableContent(
            page = this.page,
            limit = this.limit,
            sortBy = this.sortBy,
            desc = this.desc,
            fromFilter = false
        ) {
            page = fromFilter ? 1 : this.page
            limit = 9; // limit per fetch
            return await this.callLittersListAPI({ page, limit, sortBy, desc })

        },
        async callLittersListAPI(queryParams) {
            this.isAPILoading = true
            if (this.columnsFilter) {
                if (this.columnsFilter.f_puppyName) {
                    queryParams["f_puppyName"] = this.columnsFilter.f_puppyName
                }
                if (this.columnsFilter.f_identifier) {
                    queryParams["f_identifier"] = this.columnsFilter.f_identifier
                }
                if (this.columnsFilter.f_colour) {
                    queryParams["f_colour"] = this.columnsFilter.f_colour
                }
            }
            if (this.selectGender) {
                queryParams["f_gender"] = this.selectGender;
            }

            try {
                const response = await breedingManagementService.getLitterList(this.matingId, queryParams);

                if (response.status === STATUS_CODES.SUCCESS) {

                    if (this.isShowMore) {
                        this.puppyList = [...this.puppyList, ...response.data.data]
                        this.isShowMore = false
                    } else {
                        this.puppyList = response.data.data
                    }

                    this.puppyListTotalCount = response.data.pagination.totalCount;
                    this.didFetchList = true;
                } else {
                    this.showAPIErrorToast(this.toastMessages.litters().ERROR_GET_LITTER_LIST, response)
                }

            } catch (err) {
                this.showGenericErrorToast()
                this.didFetchList = false;
            } finally {
                this.isAPILoading = false
            }

            return this.totalCount;
        },
        showMore() {
			this.isShowMore = true
			this.onPageSelected("next")
		},
        showLitterDetails(litterId) {
            if (!litterId) {
                return;
            }
            this.$router.push(`${BREEDER_ROUTES.EDIT_LITTER}?id=${this.matingId}&litterId=${litterId}`);
        },
        redirectToAddLitter() {
            this.$router.push(`${BREEDER_ROUTES.ADD_LITTER}?id=${this.matingId}&from=litter-management`);
        },
        redirectToManageLitter(litterId) {
            this.$router.push(`${BREEDER_ROUTES.EDIT_LITTER}?id=${litterId}`);
        },

        redirectToReminderNotes() {
            this.$router.push(`${BREEDER_ROUTES.LITTER_REMINDER_AND_NOTES}?matingId=${this.matingId}&from=litter-list`);
        },
        redirectToWaitlist() {
            this.$router.push(`${BREEDER_ROUTES.WAIT_LIST}?matingId=${this.matingId}&from=litter-list`);
        },

        puppyImage(image) {
            return image ? image : require("@/assets/images/_shared/dog-purchase.png");
        },

        formatText(text) {
            return capitalizeFirstLetter(text)
        },
        
    },
    // third party libraries
}